import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, User, Heart } from 'lucide-react';

const navItems = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/shop', icon: ShoppingBag, label: 'Shop' },
  { to: '/account', icon: User, label: 'Account' },
  { to: '/wishlist', icon: Heart, label: 'Wishlist' },
];

export default function MobileBottomNav() {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-[var(--background)] border-t border-gray-200 dark:border-gray-800 flex justify-around items-center z-30 safe-area-pb">
      {navItems.map(({ to, icon: Icon, label }) => (
        <Link
          key={to + label}
          to={to}
          className={`flex flex-col items-center justify-center flex-1 py-2 text-sm transition ${
            location.pathname === to
              ? 'text-[var(--primary-red)] font-semibold'
              : 'text-gray-500 hover:text-[var(--primary-red)]'
          }`}
        >
          <Icon className="h-6 w-6" />
          <span>{label}</span>
        </Link>
      ))}
    </nav>
  );
}
